import { Box } from '@mui/material';
import React from 'react';
import BaseTypography from 'components/typography/BaseTypography';
import { reusableStyles } from 'ui-blocks/ReusableStyles';
import { useMediaQuery } from '@mui/system';
import { landingPageStyles } from 'layouts/pages/landing-page/landingPageStyles';
import CreateImagineVideos from './components/CreateImagineVideos';
import { createImagineStyles } from './createImagineStyles';

export default function CreateImagineSection() {
	// const isSmallScreen = useMediaQuery(appTheme.breakpoints.down('lg'));
	// TO DO
	const isSmallScreen = useMediaQuery('(max-width: 1280px)');
	return (
		<Box id="create-imagine-section" sx={[createImagineStyles.createImagineContainer]}>
			<Box sx={[reusableStyles.flexRow, { width: { xs: '100%', mobileUi: '35%', xxl: '45%' } }]}>
				<Box id="create-imagine-description" sx={[landingPageStyles.sectionDescriptionContainer]}>
					<BaseTypography
						variant="h2_zodiak"
						styles={{ color: 'colors.light3', textAlign: 'left' }}
					>
						Create anyone you imagine. Cast them however you want.
					</BaseTypography>
					<BaseTypography
						variant={isSmallScreen ? 'b2_regular' : 'b1_regular'}
						styles={{ color: 'colors.light3', textAlign: 'left' }}
					>
						Design unique AI characters from scratch. Shape their look, style, and role to fit any
						brand, story, or campaign.
					</BaseTypography>
				</Box>
			</Box>
			<CreateImagineVideos />
		</Box>
	);
}
